<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">Manage Network Outages</span>
        </div>
    </div>

    <div class="card card_content">
        <div class="row d-flex  align-items-center flex-wrap grid-margin">
            <div class="col-md-6 d-flex">
                <!-- <button type="button" class="btn btn-secondary mr-2" (click)="clearFilter()">
                    <i class="fa fa-refresh"></i> Refresh
                </button> -->
                <app-button (refreshClicked)="clearFilter()"></app-button>

                <button type="button" class="btn btn-primary text-nowrap" (click)="gotoaddoutage(0)">
                    <i class="fa fa-plus"></i> Add
                </button>
                <button type="button" class="btn btn-primary ml-2  d-flex" (click)="filterOpen = !filterOpen">
                    <ng-container *ngIf="!filterOpen">
                        <app-icon name="arrow-rounded-down-12x7" size="12x7"></app-icon>
                    </ng-container>
                    <ng-container *ngIf="filterOpen">
                        <app-icon name="arrow-rounded-up-13x8" size="13x8"></app-icon>
                    </ng-container>
                    <span class="ml-2">Filters</span>
                </button>
            </div>
        </div>
        <div [@detailExpand]="filterOpen ? 'expanded' : 'collapsed'" style="overflow: hidden;">
            <hr>
            <form [formGroup]="filterSearchForm">
                <div class="row mx-5">
                    <div class="col-xl-6 mt-4">
                        <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                            <mat-label>Start Date</mat-label>
                            <input readonly matInput appInputtext [matDatepicker]="startDate"
                                formControlName="startDate" selectable="isSelectable(date,type)" id="startDate"
                                autocomplete="off" placeholder="Please Select Start From Date"
                                class="custom-input-border" specialIsAlphaNumeric (click)="startDate.open()">
                            <mat-datepicker-toggle matSuffix [for]="startDate" style="color:black;">
                                <button mat-icon-button>
                                    <mat-icon>event</mat-icon>
                                </button>
                            </mat-datepicker-toggle>
                            <mat-datepicker #startDate></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="col-xl-6 mt-4">
                        <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                            <mat-label> End Date</mat-label>
                            <input readonly matInput appInputtext [matDatepicker]="endDate" formControlName="endDate"
                                selectable="isSelectable(date,type)" id="endDate" autocomplete="off"
                                 placeholder="Please Select End To Date" 
                                class="custom-input-border" specialIsAlphaNumeric (click)="endDate.open()">
                            <mat-datepicker-toggle matSuffix [for]="endDate" style="color:black;">
                                <button mat-icon-button>
                                    <mat-icon>event</mat-icon>
                                </button>
                            </mat-datepicker-toggle>
                            <mat-datepicker #endDate></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="col-xl-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Service Provider</mat-label>
                            <mat-select class="scrollbarcs" formControlName="serviceProviderId"
                                placeholder="Please Select Service Provider">
                                <mat-select-filter [displayMember]="'value'" [array]="serviceProviderList"
                                    (filteredReturn)="filteredList1 = $event"></mat-select-filter>
                                <mat-option *ngFor="let item of filteredList1" [value]="item.key"
                                    style="overflow-y: scroll !important;">
                                    {{item.value}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-xl-6 mt-4">
                        <mat-form-field appearance="fill" hideRequiredMarker>
                            <mat-label>Province</mat-label>
                            <mat-select class="scrollbarcs" formControlName="provinces"
                                placeholder="Please Select Province">
                                <mat-select-filter [displayMember]="'value'" [array]="provinceList"
                                    (filteredReturn)="filteredList3 = $event"></mat-select-filter>
                                <mat-option *ngFor="let item of filteredList3" [value]="item.value"
                                    style="overflow-y: scroll !important;">
                                    {{item.value}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="col-xl-12 mt-5 d-flex justify-content-center">
                        <button class="btn reset_btn mr-3 btn_danger" (click)="clearFilter()">
                            <i class="fa fa-refresh mr-2"></i>Reset
                        </button>
                        <button class="btn btn-secondary" (click)="advancedSearchClick()">
                            <i class="fa fa-search mr-2"></i>Search
                        </button>
                    </div>
                </div>
            </form>
        </div>

        <div class="table-container table-responsive mt-3 mb-4">
            <mat-table #table [dataSource]="dataSource" class="mat-table">
                <ng-container matColumnDef="serviceprovider">
                    <mat-header-cell *matHeaderCellDef>Service Provider</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p>{{dataField.serviceProviderId}}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="province">
                    <mat-header-cell *matHeaderCellDef>Province</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p>{{dataField.provinces}}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="city">
                    <mat-header-cell *matHeaderCellDef>City</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p>{{dataField.city}}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="createddate">
                    <mat-header-cell *matHeaderCellDef>Created Date</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p>{{dataField.creationTs|date:'dd/MM/yyyy hh:mm a'}}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="subject">
                    <mat-header-cell *matHeaderCellDef>Subject</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p>{{dataField.subject}}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="createduser">
                    <mat-header-cell *matHeaderCellDef>Created User</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p>{{dataField.creationUserId}}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="OutageStatus">
                    <mat-header-cell *matHeaderCellDef>Outage Status</mat-header-cell>
                    <mat-cell *matCellDef="let dataField" style="text-align: center;font-weight: bold;" [style.color]="dataField.outageStatus==0?'red !important':'green !important'">
                        <p>{{dataField.outageStatus==0?'Closed':'Open'}}</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="action">
                    <mat-header-cell *matHeaderCellDef>Action</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <div class="text-truncate text-center">
                            <i style="cursor: pointer;font-size: 18px;color: #9B02DB;" class="fa fa-edit mr-3" title="Edit"
                                (click)="gotoaddoutage(dataField.id)"></i>
                                <i style="cursor: pointer;font-size: 18px;color: green;" class="fa fa-unlock mr-3" title="Open"
                                (click)="close(dataField.id,true)" *ngIf="dataField.outageStatus == 0"> </i>
                            <i style="cursor: pointer;font-size: 18px;color: red;" class="fa fa-lock mr-3" title="Close"
                                (click)="close(dataField.id,false)"*ngIf="dataField.outageStatus == 1"></i>
                                <i style="cursor: pointer;font-size: 18px;color: #9B02DB;" class="fa fa-trash mr-3" title="Delete"
                                (click)="delete(dataField.id,false)"></i>
                        </div>
                    </mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                <mat-row *matRowDef="let row;columns:displayedColumns;" matRipple></mat-row>
            </mat-table>
            <div *ngIf="dataSource?.data?.length==0" class="no-data-message">
                <p>No Data Found</p>
            </div>
        </div>
        <div class="table_pagenation" [hidden]="dataSource?.filteredData.length<=50">
            <mat-paginator #paginator [length]="dataSource?.filteredData.length || 0" [pageIndex]="0" [pageSize]="50"
                [pageSizeOptions]="[50, 100]">
            </mat-paginator>
        </div>
    </div>
</div>  